import { useLocation } from 'react-router-dom';
import XenieNewLogo from '../../Assets/XenieNewLogo.svg';
import RegistrationProgressBar from './RegistrationProgressBar';

function RegistrationLayout({ children }) {
    const location = useLocation();

    const info = {
        "/registration": {
            heading: 'Welcome to Xenie',
            description: 'Step into the world of Xenie, where your brand\'s journey is set to be extraordinary. Begin your registration by providing us with the basic details we need to understand and support your unique vision. A few quick taps, and you\'re on your way to creating an impact in the digital marketplace.',
        },
        "/businessinformation": {
            heading: 'Step into a World of Possibilities with Xenie!',
            description: 'Welcome to the heart of Xenie! In this step, we invite you to unleash the possibilities for your brand. Verify your business details, allowing us to ensure the authenticity and integrity of your presence on our platform. Your brand story is about to unfold, and we\'re here to help you script it with success.',
        },
        "/storesetup": {
            heading: 'Craft Your Unique Presence',
            description: 'It\'s time to bring your brand to life on Xenie! In this step, you\'ll have the opportunity to craft a unique and compelling presence for your store. Choose a store name that resonates with your brand identity and provide an address that reflects the essence of your business. Your virtual storefront is waiting to showcase the best of what your brand has to offer.',
        },
        "/bankdetails": {
            heading: 'Secure Your Success',
            description: 'Congratulations on reaching the final stage! In this step, we ensure the seamless and secure flow of transactions for your brand. Enter your bank details to facilitate smooth financial transactions. Your success on Hyprcom is our priority, and we\'re here to provide you with the tools and support needed for a thriving journey in the digital marketplace.',
        },
        "/verifyEmail": {
            heading: '',
            description: '',
        },
        "/agreement": {
            heading: 'Secure Your Success',
            description: 'Congratulations on reaching the final stage! In this step, we ensure the seamless and secure flow of transactions for your brand. Enter your bank details to facilitate smooth financial transactions. Your success on Hyprcom is our priority, and we\'re here to provide you with the tools and support needed for a thriving journey in the digital marketplace.',
        },
    }

    return (
        <div className='max-w-screen h-screen flex'>
            <div className="w-2/5 bg-[#1F2937] p-10">
                <div className="w-full h-[68px] flex justify-start">
                    <div className="h-11 w-auto">
                        <img className='h-full w-auto mx-auto' src={XenieNewLogo} alt="Xenie Logo" />
                    </div>
                </div>

                <div className="mt-36 flex flex-col gap-[9px]">
                    <h1 className='font-bold text-[32px] leading-10 text-[#FFFFFF]'>{info[location.pathname]['heading']}</h1>

                    <p className='font-medium text-[16px] leading-[26px] text-[#B0B0B0]'>{info[location.pathname]['description']}</p>
                </div>
            </div>

            <div className="w-3/5 overflow-y-scroll bg-gray-50">
                <div className="min-h-full px-[30px] py-10">
                    <h1 className="text-[32px] leading-9 text-text1 font-semibold">Partner with Xenie</h1>

                    <div className="mt-7 w-full">
                        <RegistrationProgressBar />
                    </div>

                    <div className={`${location.pathname.includes('agreement') ? 'px-4' : 'px-[146px]'} mt-10 w-full pb-10`}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RegistrationLayout;
